var path = '/templates/projects.segments/campaign_segment_show_custom.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_show_custom.html
// module id = 1492
// module chunks = 0